"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const schema = {
    type: "object",
    properties: {
        visitDate: {
            type: "number",
            format: "date",
            disableFuture: true,
            title: "Discharge Date",
        },
        withVisit: {
            type: "boolean",
            default: true,
            oneOf: [
                { const: true, title: "Yes" },
                { const: false, title: "No" },
            ],
        },
        nameOfPersonSpokenTo: {
            type: "string",
            title: "Contact Person Name at Doctor's Office",
        },
        informedPhysician: {
            type: "string",
            title: "Notified Physician",
            default: "No",
            oneOf: [
                { const: "Yes", title: "Yes" },
                { const: "No", title: "No" },
            ],
        },
        notes: {
            type: "string",
            title: "Notes",
            maxLength: 3000,
        },
    },
    required: ["visitDate"],
};
exports.default = schema;
